import React from 'react';
import { Drawer, List, ListItem, ListItemText, Accordion, AccordionSummary, AccordionDetails, Typography } from '@mui/material';
import { NavLink } from 'react-router-dom';
import { MdExpandMore, MdClose } from 'react-icons/md';

const MobileMenu = ({ open, toggleDrawer, data }) => (
  <Drawer anchor="right" open={open} onClose={toggleDrawer(false)}>
    <div className="w-80 h-full bg-zinc-800 text-white overflow-y-auto">
      {/* Header with close button */}
      <div className="flex justify-between items-center p-4 border-b border-slate-600">
        <h3 className="text-lg font-semibold">Menu</h3>
        <button 
          onClick={toggleDrawer(false)}
          className="text-white hover:text-gray-300 p-1"
        >
          <MdClose size={24} />
        </button>
      </div>
      
      <List className='!py-0'>
        {data.map((item, index) =>
          item.dropdown ?
            <Accordion key={index} className='!shadow-none flex flex-col !bg-zinc-800 !text-white border-b border-slate-600'>
              <AccordionSummary 
                className='self-center min-h-[48px]' 
                expandIcon={<MdExpandMore className='text-white' />} 
                aria-controls={`panel${index}-content`} 
                id={`panel${index}-header`}
              >
                <Typography className="font-medium">{item.name}</Typography>
              </AccordionSummary>
              <AccordionDetails className='!p-0 !bg-zinc-700'>
                <List className='!py-0 w-full'>
                  {item.submenu.map((subitem, subindex) =>
                    <NavLink 
                      key={subindex} 
                      to={subitem.url} 
                      onClick={toggleDrawer(false)} 
                      className={({ isActive }) => `block w-full ${isActive ? 'bg-blue-600' : 'hover:bg-zinc-600'}`}
                    >
                      <ListItem className='w-full border-b border-slate-600 last:border-b-0'>
                        <ListItemText className='text-center' primary={subitem.name} />
                      </ListItem>
                    </NavLink>
                  )}
                </List>
              </AccordionDetails>
            </Accordion>
            :
            <NavLink 
              key={index} 
              to={item.url} 
              onClick={toggleDrawer(false)} 
              className={({ isActive }) => `block w-full ${isActive ? 'bg-blue-600' : 'hover:bg-zinc-700'}`}
            >
              <ListItem className='border-b border-slate-600 !text-center min-h-[48px]'>
                <ListItemText primary={item.name} />
              </ListItem>
            </NavLink>
        )}
      </List>
    </div>
  </Drawer>
);

export default MobileMenu;
